export default __webpack_public_path__ + "static/media/Phone.aea3db10.svg";